<template>
	<el-dialog class="account-settings" title="设置" :visible.sync="visible" width="420px" top="18vh"
		:before-close="onClose" append-to-body>
		<div class="settings-list">
			<div class="settings-row action-row" @click="openPasswordDialog">
				<div class="settings-row-main">
					<i class="el-icon-lock row-icon password-icon"></i>
					<span class="settings-title">修改密码</span>
				</div>
				<button type="button" class="settings-action" @click.stop="openPasswordDialog">
					<i class="el-icon-arrow-right"></i>
				</button>
			</div>
			<div class="settings-row sound-toggle-row" :class="{ 'with-sound-actions': messageSoundEnabled }">
				<div class="settings-row-main">
					<i class="el-icon-bell row-icon sound-icon"></i>
					<span class="settings-title">消息提示音</span>
				</div>
				<div class="settings-row-side">
					<el-switch v-model="messageSoundEnabled" active-color="#2f80ed" @change="onMessageSoundChange"></el-switch>
				</div>
			</div>
			<div v-if="messageSoundEnabled" class="sound-actions">
				<el-button size="mini" type="primary" plain @click.stop="openSoundDialog">更改提示音</el-button>
				<el-button size="mini" plain @click.stop="restoreDefaultMessageSound">恢复默认提示音</el-button>
			</div>
			<div class="settings-row sound-toggle-row" :class="{ 'with-sound-actions': callSoundEnabled }">
				<div class="settings-row-main">
					<i class="el-icon-video-camera-solid row-icon call-sound-icon"></i>
					<span class="settings-title">语音视频提示音</span>
				</div>
				<div class="settings-row-side">
					<el-switch v-model="callSoundEnabled" active-color="#2f80ed" @change="onCallSoundChange"></el-switch>
				</div>
			</div>
			<div v-if="callSoundEnabled" class="sound-actions">
				<el-button size="mini" type="primary" plain @click.stop="openCallSoundDialog">更改提示音</el-button>
				<el-button size="mini" plain @click.stop="restoreDefaultCallSound">恢复默认提示音</el-button>
			</div>
			<div class="settings-row">
				<div class="settings-row-main">
					<i class="el-icon-user-solid row-icon verify-icon"></i>
					<span class="settings-title">加我为好友时需要验证</span>
				</div>
				<el-switch v-model="friendVerifyEnabled" active-color="#2f80ed" :loading="friendVerifyLoading"
					@change="onFriendVerifyChange"></el-switch>
			</div>
		</div>

		<el-dialog class="password-dialog" title="修改密码" :visible.sync="passwordDialogVisible" width="420px"
			top="22vh" append-to-body>
			<el-form ref="passwordFormRef" :model="passwordForm" :rules="passwordRules" label-position="top" size="small">
				<el-form-item label="原密码" prop="oldPassword">
					<el-input v-model="passwordForm.oldPassword" type="password" show-password autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item label="新密码" prop="newPassword">
					<el-input v-model="passwordForm.newPassword" type="password" show-password autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item label="确认密码" prop="confirmPassword">
					<el-input v-model="passwordForm.confirmPassword" type="password" show-password autocomplete="off"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="password-footer">
				<el-button size="small" @click="passwordDialogVisible = false">取消</el-button>
				<el-button size="small" type="primary" :loading="passwordSubmitting" @click="submitPassword">提交</el-button>
			</div>
		</el-dialog>
		<el-dialog class="sound-dialog" title="更改提示音" :visible.sync="soundDialogVisible" width="420px"
			top="22vh" append-to-body>
			<div class="sound-option-list">
				<div v-for="item in messageSoundOptions" :key="item.key" class="sound-option">
					<el-radio v-model="messageSoundKey" :label="item.key" @change="onMessageSoundSelect">
						{{ item.name }}
					</el-radio>
					<el-button size="mini" icon="el-icon-video-play" @click="previewMessageSound(item)">试听</el-button>
				</div>
			</div>
		</el-dialog>
		<el-dialog class="sound-dialog" title="更改语音视频提示音" :visible.sync="callSoundDialogVisible" width="420px"
			top="22vh" append-to-body>
			<div class="sound-option-list">
				<div v-for="item in callSoundOptions" :key="item.key" class="sound-option">
					<el-radio v-model="callSoundKey" :label="item.key" @change="onCallSoundSelect">
						{{ item.name }}
					</el-radio>
					<el-button size="mini" icon="el-icon-video-play" @click="previewCallSound(item)">试听</el-button>
				</div>
			</div>
		</el-dialog>
	</el-dialog>
</template>

<script>
import {
	DEFAULT_MESSAGE_SOUND_KEY,
	MESSAGE_SOUND_OPTIONS,
	MESSAGE_SOUND_STORAGE_KEY,
	getMessageSoundOption
} from '@/config/messageSoundOptions';
import {
	CALL_SOUND_ENABLED_STORAGE_KEY,
	CALL_SOUND_OPTIONS,
	CALL_SOUND_STORAGE_KEY,
	DEFAULT_CALL_SOUND_KEY,
	getCallSoundOption
} from '@/config/callSoundOptions';

export default {
	name: "account-settings",
	props: {
		visible: {
			type: Boolean
		}
	},
	data() {
		const validateNewPassword = (rule, value, callback) => {
			if (!value) {
				callback(new Error('请输入新密码'));
				return;
			}
			if (value === this.passwordForm.oldPassword) {
				callback(new Error('新密码不能和原密码一致'));
				return;
			}
			if (this.passwordForm.confirmPassword && this.passwordForm.confirmPassword !== value) {
				callback(new Error('两次输入的密码不一致'));
				return;
			}
			callback();
		};
		const validateConfirmPassword = (rule, value, callback) => {
			if (!value) {
				callback(new Error('请输入确认密码'));
				return;
			}
			if (value !== this.passwordForm.newPassword) {
				callback(new Error('两次输入的密码不一致'));
				return;
			}
			callback();
		};
		return {
			messageSoundEnabled: true,
			messageSoundKey: DEFAULT_MESSAGE_SOUND_KEY,
			messageSoundOptions: MESSAGE_SOUND_OPTIONS,
			soundDialogVisible: false,
			callSoundEnabled: true,
			callSoundKey: DEFAULT_CALL_SOUND_KEY,
			callSoundOptions: CALL_SOUND_OPTIONS,
			callSoundDialogVisible: false,
			previewAudio: null,
			friendVerifyEnabled: true,
			friendVerifyLoading: false,
			passwordDialogVisible: false,
			passwordSubmitting: false,
			passwordForm: {
				oldPassword: '',
				newPassword: '',
				confirmPassword: ''
			},
			passwordRules: {
				oldPassword: [{
					required: true,
					message: '请输入原密码',
					trigger: 'blur'
				}],
				newPassword: [{
					validator: validateNewPassword,
					trigger: 'blur'
				}],
				confirmPassword: [{
					validator: validateConfirmPassword,
					trigger: 'blur'
				}]
			}
		};
	},
	methods: {
		onClose() {
			this.passwordDialogVisible = false;
			this.soundDialogVisible = false;
			this.callSoundDialogVisible = false;
			this.stopPreviewAudio();
			this.$emit("close");
		},
		openDialogData() {
			this.loadMessageSoundSetting();
			this.loadCallSoundSetting();
			this.loadFriendVerifySetting();
		},
		loadMessageSoundSetting() {
			const saved = localStorage.getItem('messageSoundEnabled');
			this.messageSoundEnabled = saved !== 'false';
			this.messageSoundKey = getMessageSoundOption(localStorage.getItem(MESSAGE_SOUND_STORAGE_KEY)).key;
		},
		onMessageSoundChange(value) {
			this.messageSoundEnabled = value;
			localStorage.setItem('messageSoundEnabled', String(value));
			this.$message.success(value ? '消息提示音已开启' : '消息提示音已关闭');
		},
		openSoundDialog() {
			this.soundDialogVisible = true;
		},
		onMessageSoundSelect(value) {
			this.messageSoundKey = getMessageSoundOption(value).key;
			localStorage.setItem(MESSAGE_SOUND_STORAGE_KEY, this.messageSoundKey);
			this.$message.success('消息提示音已更新');
		},
		restoreDefaultMessageSound() {
			this.messageSoundKey = DEFAULT_MESSAGE_SOUND_KEY;
			localStorage.setItem(MESSAGE_SOUND_STORAGE_KEY, this.messageSoundKey);
			this.$message.success('已恢复默认提示音');
		},
		previewMessageSound(item) {
			this.previewSound(item);
		},
		loadCallSoundSetting() {
			const saved = localStorage.getItem(CALL_SOUND_ENABLED_STORAGE_KEY);
			this.callSoundEnabled = saved !== 'false';
			this.callSoundKey = getCallSoundOption(localStorage.getItem(CALL_SOUND_STORAGE_KEY)).key;
		},
		onCallSoundChange(value) {
			this.callSoundEnabled = value;
			localStorage.setItem(CALL_SOUND_ENABLED_STORAGE_KEY, String(value));
			if (!value) {
				this.stopPreviewAudio();
			}
			this.$message.success(value ? '语音视频提示音已开启' : '语音视频提示音已关闭');
		},
		openCallSoundDialog() {
			this.callSoundDialogVisible = true;
		},
		onCallSoundSelect(value) {
			this.callSoundKey = getCallSoundOption(value).key;
			localStorage.setItem(CALL_SOUND_STORAGE_KEY, this.callSoundKey);
			this.$message.success('语音视频提示音已更新');
		},
		restoreDefaultCallSound() {
			this.callSoundKey = DEFAULT_CALL_SOUND_KEY;
			localStorage.setItem(CALL_SOUND_STORAGE_KEY, this.callSoundKey);
			this.$message.success('已恢复默认语音视频提示音');
		},
		previewCallSound(item) {
			this.previewSound(item);
		},
		previewSound(item) {
			this.stopPreviewAudio();
			const audio = new Audio();
			audio.src = item.src;
			this.previewAudio = audio;
			audio.play().catch((error) => {
				console.warn('试听提示音失败:', error);
			});
		},
		stopPreviewAudio() {
			if (this.previewAudio) {
				this.previewAudio.pause();
				this.previewAudio.currentTime = 0;
				this.previewAudio = null;
			}
		},
		loadFriendVerifySetting() {
			this.friendVerifyLoading = true;
			this.$http({
				url: "/user/friend-verify",
				method: "GET"
			}).then((res) => {
				const enabled = res && typeof res === 'object' ? res.enabled : res;
				this.friendVerifyEnabled = enabled !== false;
			}).catch((error) => {
				console.error('加载加好友验证设置失败:', error);
				this.friendVerifyEnabled = true;
			}).finally(() => {
				this.friendVerifyLoading = false;
			});
		},
		onFriendVerifyChange(value) {
			const previousValue = !value;
			this.friendVerifyLoading = true;
			this.$http({
				url: "/user/friend-verify",
				method: "POST",
				data: { enabled: value }
			}).then(() => {
				this.$message.success(value ? '已开启好友验证' : '已关闭好友验证');
			}).catch((error) => {
				console.error('更新加好友验证设置失败:', error);
				this.friendVerifyEnabled = previousValue;
			}).finally(() => {
				this.friendVerifyLoading = false;
			});
		},
		openPasswordDialog() {
			this.passwordDialogVisible = true;
			this.passwordForm = {
				oldPassword: '',
				newPassword: '',
				confirmPassword: ''
			};
			this.$nextTick(() => {
				if (this.$refs.passwordFormRef) {
					this.$refs.passwordFormRef.clearValidate();
				}
			});
		},
		submitPassword() {
			this.$refs.passwordFormRef.validate((valid) => {
				if (!valid) {
					return false;
				}
				this.passwordSubmitting = true;
				this.$http({
					url: "/modifyPwd",
					method: "PUT",
					data: this.passwordForm
				}).then(() => {
					this.$message.success('修改密码成功');
					this.passwordDialogVisible = false;
				}).finally(() => {
					this.passwordSubmitting = false;
				});
			});
		}
	},
	watch: {
		visible(value) {
			if (value) {
				this.openDialogData();
			}
		}
	},
	beforeDestroy() {
		this.stopPreviewAudio();
	}
}
</script>

<style scoped lang="scss">
.account-settings {
	::v-deep .el-dialog__header {
		text-align: center;
		padding: 18px 44px 14px;
		border-bottom: 1px solid #edf0f5;
	}

	::v-deep .el-dialog__title {
		font-size: 18px;
		font-weight: 600;
		color: #111827;
	}

	::v-deep .el-dialog__body {
		padding: 12px 0;
		background: #f6f7fb;
	}
}

.settings-list {
	background: #ffffff;
}

.settings-row {
	height: 58px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 0 24px;
	border-bottom: 1px solid #f0f2f5;
	box-sizing: border-box;
}

.settings-row:last-child {
	border-bottom: none;
}

.sound-toggle-row.with-sound-actions {
	border-bottom: none;
}

.action-row {
	cursor: pointer;
}

.settings-row-main {
	min-width: 0;
	display: flex;
	align-items: center;
}

.settings-row-side {
	display: flex;
	align-items: center;
	gap: 14px;
}

.sound-actions {
	display: flex;
	align-items: center;
	gap: 8px;
	min-height: 46px;
	padding: 0 24px 12px 60px;
	border-bottom: 1px solid #f0f2f5;
	box-sizing: border-box;
	white-space: nowrap;
}

.row-icon {
	width: 24px;
	margin-right: 12px;
	font-size: 20px;
	text-align: center;
}

.password-icon {
	color: #77a94b;
}

.sound-icon {
	color: #58a73e;
}

.call-sound-icon {
	color: #df4c8d;
}

.verify-icon {
	color: #e46767;
}

.settings-title {
	font-size: 15px;
	color: #111827;
	white-space: nowrap;
}

.settings-action {
	width: 32px;
	height: 32px;
	border: 0;
	padding: 0;
	display: inline-flex;
	align-items: center;
	justify-content: flex-end;
	background: transparent;
	color: #9ca3af;
	font-size: 18px;
	cursor: pointer;
}

.settings-action:hover {
	color: #2f80ed;
}

.password-dialog {
	::v-deep .el-dialog__body {
		padding: 18px 24px 4px;
	}

	::v-deep .el-form-item__label {
		line-height: 20px;
		padding-bottom: 7px;
	}
}

.password-footer {
	text-align: right;
}

.sound-dialog {
	::v-deep .el-dialog__body {
		padding: 8px 24px 18px;
	}
}

.sound-option-list {
	display: flex;
	flex-direction: column;
}

.sound-option {
	height: 48px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	border-bottom: 1px solid #f0f2f5;
}

.sound-option:last-child {
	border-bottom: none;
}
</style>
